import clsx from 'clsx';
import { useProductInfoLabels } from '../../hooks/useProductInfoLabels';
import { ProductInfoLabel } from '../ProductInfoLabel/ProductInfoLabel';
import styles from './ProductInfoLabels.module.scss';

type Props = React.HTMLAttributes<HTMLDivElement>;

/**
 * Every regulatory label the product carries, stacked. Renders nothing when it carries none, so
 * the caller places it without having to ask whether there is anything to place.
 */
export const ProductInfoLabels: React.FC<Props> = ({ className, ...rest }) => {
    const labels = useProductInfoLabels();

    if (!labels.length) return null;

    return (
        <div className={clsx(styles.productInfoLabels, className)} {...rest}>
            {labels.map(({ id, ...label }) => (
                <ProductInfoLabel key={id} {...label} />
            ))}
        </div>
    );
};
